import { render, staticRenderFns } from "./UpdateStudent.vue?vue&type=template&id=5f4681a0&scoped=true"
import script from "./UpdateStudent.vue?vue&type=script&lang=js"
export * from "./UpdateStudent.vue?vue&type=script&lang=js"
import style0 from "./UpdateStudent.vue?vue&type=style&index=0&id=5f4681a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4681a0",
  null
  
)

export default component.exports